<template>
  <v-img
      src="@/assets/highlights.png"
      width="250"
      class="image fixed px-3 pt-3 pb-8 mb-5"
      height="510"
  >
    <div ref="speakerPreviewContainer" v-resize="getSpeakerPreviewWidth">
      <v-card
          :class="[{ 'rounded-corners': !isWebPage }, 'mb-3 overflow-y-auto  overflow-x-hidden']"
          :height="height"
          :max-height="maxHeight"
      >
        <v-col class="pa-0 justify-center align-center" align-self="center">

          <v-avatar size="40" class="centerAvatar">
            <v-img :src="speaker.displayImageURL" max-width="100%" height="100%"></v-img>
          </v-avatar>

          <v-col cols="12" align-self="center" class="justify-center align-center pa-0">
            <div class="text-center">
              <v-card-text class="pa-0" align-self="center">
                {{ speaker.firstName }} {{ speaker.lastName }}
              </v-card-text>
            </div>
            <div class="text-center ">
              <v-card-text class="pa-0 text-caption" align-self="center">
                {{ speaker.jobTitle }} at {{ speaker.businessName }}
              </v-card-text>
            </div>
            <div class="text-center pt-2 pb-4">
              <v-card-text class="pa-0 text-caption" align-self="center">
                <span class="socialIconBg pa-2 rounded-corners">Speaker</span>
              </v-card-text>
            </div>
          </v-col>
          <v-col cols="12" align-self="center" class="justify-center align-center pa-0">
            <div class="flex">
              <v-spacer></v-spacer>
              <v-btn
                     color="#FEF3EE"
                     depressed
                     small
                     class="buttonStyle fixed btn primary--text">
                <v-icon left>mdi-chat-processing-outline</v-icon>
                Message
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary"
                     depressed
                     small
                     class="buttonStyle fixed">
                <v-icon left>mdi-account-plus-outline</v-icon>
                 Connect
              </v-btn>
              <v-spacer></v-spacer>

            </div>

          </v-col>

          <v-divider class="thickDivider my-4"></v-divider>
          <v-card-text v-if="this.speakingAt.length > 0" class="px-2 pb-2 pt-0 text--black font-weight-bold">Speaking At</v-card-text>
          <div v-for="speaking in this.speakingAt">
            <v-col class="pb-2 ma-0 px-0">
              <v-row class="pb-6 px-6">
                <img :src="speaking.subEventImageURL" height="20" width="20" class="rounded-lg"/>
                <span class="pl-2">{{speaking.subEventName}}</span>
              </v-row>
              <div v-for="session in speaking.sessions" class="px-2 ma-0">
                <v-card-text class="pa-0 text-caption ma-0" >
                  <span class="socialIconBg pa-2 ml-0 rounded-corners">{{session}}</span>
                </v-card-text>
              </div>

            </v-col>


          </div>
          <v-col cols="12">
            <v-card-subtitle class="pa-0 ma-0 text--black font-weight-bold">
              Bio
            </v-card-subtitle>
            <v-card-text class="pa-0 ma-0 text--black text-sm-caption" style="white-space: pre-line">
              {{ speaker.bio }}
            </v-card-text>

            <v-divider class="my-2"/>

            <v-card-subtitle v-if="socials.filter((e) => e.url!='').length > 0" class="pa-0 ma-0 text--black font-weight-bold">
              Socials
            </v-card-subtitle>
            <v-row align="center" justify="center">
              <div v-for="social in socials">
                <div class="pa-2 mx-1 rounded-corners socialIconBg" v-if="social.url!=''">
                  <v-img :src="require(`@/assets/${social.icon}`)" height="10" width="10" contain class="ma-0 pa-0"
                         max-width="10"/>
                </div>
              </div>
            </v-row>
          </v-col>
        </v-col>
      </v-card>

    </div>
  </v-img>
</template>

<script>
import Speaker from "@/models/Speaker";
import {getEventDoc} from "@/shared/firebase_utils";

export default {
  name: "SpeakerPreview",
  data() {
    return {
      speakingAt: [],
    }
  },
  computed: {
    socials() {
      return [
        {
          icon: 'facebook-icon.svg',
          url: this.speaker.facebook,
        },
        {
          icon: 'instagram-icon.svg',
          url: this.speaker.instagram,
        },
        {
          icon: 'linkedin-icon.svg',
          url: this.speaker.linkedin,
        },
        {
          icon: 'twitter-icon.svg',
          url: this.speaker.twitter,
        },
        {
          icon: 'youtube-icon.svg',
          url: this.speaker.youtube,
        },
        {
          icon: 'podcast-icon.svg',
          url: this.speaker.podcast,
        }
      ]
    }
  },
  props: {
    speaker: {
      type: Speaker,
      required: true,
    },
    height: {type: String},
    maxHeight: {type: String},
    isWebPage: {type: Boolean, default: false},
  },
  created() {
    this.getSpeakingAtDetails();
  },
  methods: {
    getSpeakerPreviewWidth() {
      if (this.$refs.speakerPreviewContainer != null) this.x = this.$refs.speakerPreviewContainer.clientWidth;
    },
    async getSpeakingAtDetails() {

      const uniqueSubEvents = [];
      const addedSubEvents = [];
      this.speaker.speakerRelations.forEach((relation) => {
        if (!uniqueSubEvents.includes(relation.subEventId)) {
          uniqueSubEvents.push(relation.subEventId);
        }
      });
      for (const subEventId of uniqueSubEvents) {
        const subEvent = await getEventDoc(subEventId);
        const relatedSessions = [];
        const relatedSessionIds = this.speaker.speakerRelations.filter((relation) => relation.subEventId === subEventId).map((relation) => relation.sessionId);
        for (const sessionId of relatedSessionIds) {
          const session = await getEventDoc(sessionId);
          relatedSessions.push(session.data());
        }
        console.log(relatedSessions);
        this.speakingAt.push({
          subEventName: subEvent.data().name,
          subEventImageURL: subEvent.data().coverImageURL,
          sessions: relatedSessions.map((session) => session.name),
        });
      }
    }
  }
}
</script>
<style>
.socialIconBg {
  background: #0024340A
}

.rounded-corners {
  border-radius: 20px !important;
}

.centerAvatar {
  text-align: center;
  margin: 20px 100px 20px 90px;
}

.flex {
  display: flex;
}

.thickDivider {
  border-width: 3px !important;
  color: #F6F7FC !important;
  height: 100%;
}

.buttonStyle {
  font-size: 4px;
}
</style>